export const MaskPortal = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_4178_39375" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
      <path
        d="M24.7497 12.6654C27.7412 12.6654 30.1663 10.2402 30.1663 7.2487C30.1663 4.25716 27.7412 1.83203 24.7497 1.83203C21.7581 1.83203 19.333 4.25716 19.333 7.2487C19.333 10.2402 21.7581 12.6654 24.7497 12.6654Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M24.7497 30.1654C27.7412 30.1654 30.1663 27.7402 30.1663 24.7487C30.1663 21.7572 27.7412 19.332 24.7497 19.332C21.7581 19.332 19.333 21.7572 19.333 24.7487C19.333 27.7402 21.7581 30.1654 24.7497 30.1654Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M7.24967 12.6654C10.2412 12.6654 12.6663 10.2402 12.6663 7.2487C12.6663 4.25716 10.2412 1.83203 7.24967 1.83203C4.25813 1.83203 1.83301 4.25716 1.83301 7.2487C1.83301 10.2402 4.25813 12.6654 7.24967 12.6654Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M7.24967 30.1654C10.2412 30.1654 12.6663 27.7402 12.6663 24.7487C12.6663 21.7572 10.2412 19.332 7.24967 19.332C4.25813 19.332 1.83301 21.7572 1.83301 24.7487C1.83301 27.7402 4.25813 30.1654 7.24967 30.1654Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
    </mask>
    <g mask="url(#mask0_4178_39375)">
      <path d="M-4 -4H36V36H-4V-4Z" fill="#BBD0FB" />
    </g>
  </svg>
);
